import { render, staticRenderFns } from "./VlModalTemplate.vue?vue&type=template&id=4b6cc848&scoped=true&"
import script from "./VlModalTemplate.vue?vue&type=script&lang=js&"
export * from "./VlModalTemplate.vue?vue&type=script&lang=js&"
import style0 from "./VlModalTemplate.vue?vue&type=style&index=0&id=4b6cc848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6cc848",
  null
  
)

export default component.exports